import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const CustomButtonContainer = styled.div`
  display: flex;
  justify-content: center;

  .customButton {
    display: flex;
    justify-content: center;
    height: 35px;
    width: 35px;
    border-radius: 35px;
    box-shadow: ${v.boxShadow};
    line-height: 20px;
    padding: 0px;
    align-items: center;

    &:hover {
      box-shadow: ${v.boxShadowHover};
    }
  }

  .customButton.gray {
    background: ${v.btnGray};
  }

  .customButton.red {
    background-image: ${v.btnRed};
  }

  .customButton.orange {
    box-shadow: ${v.boxShadow};
    background: ${v.ezMainColor};
  }

  .customButton.green {
    background-image: ${v.btnGreen};
  }

  .customButton.blue {
    background-image: ${v.btnBlue};
  }

  .customButton.white {
    background: #FFF;
  }

  .customButton.white .btnTitle {
    color: ${v.ezMainColor};
  }

  .customButton.orange:active,
  .customButton.orange:focus {
    background-color: ${v.ezMainColor};
  }

  .customButton.orange:hover {
    background-color: ${v.ezMainColor};
    box-shadow: ${v.boxShadowHover};
  }

  .customButton .btnTitle {
    font-size: 1.25rem !important;
    font-weight: normal;
    color: #FFF;
  }

  .customButton svg {
    margin-right: 5px;
  }

  .customButton svg path {
    color: #FFFFFF;
  }

  .btnTitle {
    display: none;
  }

  @media only screen and (min-width: 600px) {
    .btnTitle {
      display: block;
    }

    .customButton {
      padding: 0px 15px;
      width: auto;
    }

    .customButton svg {
      margin-right: 0px;
    }
  }

  @media only screen and (min-width: 769px) {
    .btnTitle {
      display: block;
    }

    .customButton {
      padding: 0px 15px;
      width: auto;
    }

    .customButton svg {
      margin-right: 0px;
    }
  }
`